var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1210 1210",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M873 800.159c0 93.993-29.705 170.146-89.09 228.51-59.397 58.324-136.482 87.493-231.23 87.493-87.43 0-161.335-28.671-221.716-85.999-60.406-57.354-90.597-129.331-90.597-216.008 0-95.334 36.372-215.994 109.115-362.004 54.71-109.982 123.775-221.983 207.208-335.989C767.551 410.174 873 638.173 873 800.159Zm-104.108-7.701c0-61.211-27.688-148.718-83.075-262.519-38.708-79.18-81.759-154.375-129.126-225.586-141.49 234.232-212.215 402.604-212.215 505.078 0 55.247 20.345 102.652 61.058 142.242 40.701 39.577 88.745 59.385 144.146 59.385 65.399 0 118.271-20.127 158.653-60.394 40.367-40.254 60.559-92.985 60.559-158.206z",
    transform: "translate(48.316 -11.162)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.4763dfcc7ae0081402f3845978a2e7ca.svg";
export { ForwardRef as ReactComponent };